import CreateTeam from './CreateTeam';

export default CreateTeam;
